import React from 'react';
import Navbar from './Navbar';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1 container mx-auto px-4 py-6 md:px-6 lg:px-8">
        {children}
      </main>
      <footer className="bg-black py-4">
        <div className="container mx-auto px-4 text-center text-white text-sm">
          &copy; {new Date().getFullYear()} UCF Lab Inventory System. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Layout;
